export default function CTASection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-[900px] mx-auto flex flex-col items-center text-center">
        <div className="w-full rounded-3xl overflow-hidden mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20warm-toned%20product%20photography%20of%20beautifully%20arranged%20curated%20lifestyle%20items%20on%20a%20textured%20sand-colored%20linen%20surface%2C%20soft%20golden%20afternoon%20light%20casting%20long%20gentle%20shadows%2C%20various%20fashion%20accessories%20and%20home%20objects%20organized%20harmoniously%2C%20cream%20beige%20and%20warm%20terracotta%20palette%2C%20Scandinavian%20editorial%20aesthetic%2C%20serene%20and%20inviting%20atmosphere%2C%20premium%20catalog%20quality%2C%20no%20branding%20or%20text%20visible&width=1200&height=600&seq=cta-product-v2-2026&orientation=landscape"
            alt="Open Superbuy Spreadsheet now for curated shopping links"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-3 max-w-[650px]">
          Ready to experience
          <br />
          <span className="italic text-accent-500 font-normal">smarter spreadsheet shopping</span>?
        </h2>

        <p className="text-sm text-foreground-600 mb-10 max-w-[420px] leading-relaxed">
          Join thousands of savvy shoppers who use Superbuy Spreadsheet daily to discover the best products across every category.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-10 py-4 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all text-base whitespace-nowrap cursor-pointer"
        >
          Open Superbuy Spreadsheet Now
          <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
        </a>

        <p className="text-xs text-foreground-400 mt-5">
          Free to browse &bull; Daily updates &bull; 50,000+ products
        </p>
      </div>
    </section>
  );
}